import setJwt from '@/api/middleware/setJwt'
import { getRequest, postRequestNoAuth, putRequest } from '@/api/requests'
import { User } from '@/store/userStore'

interface LoginData {
  email: string
  password: string
}

export interface LoginResponse {
  token: string
  expiresOn: string
}

interface RegisterData {
  firstName: string
  lastName: string
  email: string
  password: string
  gender: 'FEMALE' | 'MALE' | undefined
  birthDate: string
  telephone: string | undefined | null
  marketing: boolean
}

interface RegisterResponse {
  token: string
  expiresOn: string
}

interface ForgotPasswordData {
  email: string
}

interface ResetPasswordData {
  userId: string
  token: string
  password: string
}

interface PutUserMe {
  firstName: string
  lastName: string
  birthDate: string
  gender: 'FEMALE' | 'MALE'
}

export const registerService = async (data: RegisterData) => {
  const response = await postRequestNoAuth<RegisterResponse>('/v1/users', { ...data })
  return response
}

export const loginService = async (data: LoginData) => {
  const response = await postRequestNoAuth<LoginResponse>('/v1/auth/login', { ...data })
  if (response.status === 200) {
    setJwt(response.data as LoginResponse)
  }
  return response
}

export const userDetailsService = async () => {
  const response = await getRequest<User>('/v1/users/me', {})
  return response
}

export const logoutService = async () => {
  const response = getRequest('/v1/auth/logout', {})
  return response
}

export const confirmEmailService = async (id: String, token: String) => {
  const response = await postRequestNoAuth(`/v1/users/${id}/confirm-email`, {
    token: token
  })
  return response
}

export const forgotPasswordService = async (data: ForgotPasswordData) => {
  const response = await postRequestNoAuth('/v1/auth/recover', { ...data })
  return response
}

export const resetPasswordService = async (data: ResetPasswordData) => {
  const response = await postRequestNoAuth(`/v1/users/${data.userId}/reset-password`, {
    ...data
  })
  return response
}

export const putUserMe = async (data: PutUserMe) => {
  const response = await putRequest(`/v1/users/me`, { ...data })
  return response
}
